export default (params) => ({
  trigger: {
    name: 'product_specifications.select_product_specifications_tab',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'specifications_product_tab',
        method: 'link',
      },
    },
  },
});
